import { createContext } from 'react';
import {
	IItemForGetShortInfoWithStatus,
	IModGroupParentItem,
	IModGroupChildItem,
	IUpdateModGroupRestaurantProperties,
	IServerError,
	ICircularReferenceValidationError,
} from 'types';

export type TTypeOfModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'saveAsPatch'
	| 'editInclusive'
	| 'success'
	| 'error'
	| 'errorWithInfo';

export interface IEditModGroupRestaurantPropertiesState {
	needRefetchRestPropsData: boolean;
	customerId: string;
	customerName: string;
	fetchedRestaurants: IItemForGetShortInfoWithStatus[];
	IDSelectedRestaurant: Nullable<string>;
	modGroupId: string;
	modGroupName: string;
	forceDisable: boolean;
	isPortionFlow: boolean;
	parents: IModGroupParentItem[];
	children: IModGroupChildItem[];
	dataForSubmit: Nullable<IUpdateModGroupRestaurantProperties>;
	typeOfModalWindow: TTypeOfModalWindow;
	errorResponseData: Nullable<IServerError<ICircularReferenceValidationError>>;
}

export const editModGroupRestaurantPropertiesInitialState: IEditModGroupRestaurantPropertiesState = {
	needRefetchRestPropsData: false,
	customerId: '',
	customerName: '',
	fetchedRestaurants: [],
	IDSelectedRestaurant: null,
	modGroupId: '',
	modGroupName: '',
	forceDisable: false,
	isPortionFlow: false,
	parents: [],
	children: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
	errorResponseData: null,
};

export interface IEditModGroupRestaurantPropertiesContext extends IEditModGroupRestaurantPropertiesState {
	refetchRestPropsData(value: boolean): void;
	setIDRestaurant(value: Nullable<string>): void;
	toggleForceDisable(): void;
	setChildren(value: IModGroupChildItem[]): void;
	setDataForSubmit(data: IUpdateModGroupRestaurantProperties): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	showErrorModalWithInfo(value: Nullable<IServerError<ICircularReferenceValidationError>>): void;
}

export const EditModGroupRestaurantPropertiesContext = createContext<IEditModGroupRestaurantPropertiesContext>({
	refetchRestPropsData: () => undefined,
	setIDRestaurant: () => undefined,
	toggleForceDisable: () => undefined,
	setChildren: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	showErrorModalWithInfo: () => undefined,
	...editModGroupRestaurantPropertiesInitialState,
});
